let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
    <ownerCode>货主编码, string (50), 必填</ownerCode>    
    <wmsOrderCode>WMS订单号, string (50), 必填</wmsOrderCode>
    <erpOrderCode>ERP订单号, string (50), 必填</erpOrderCode>
    <transferCode>转运单号, string (50)，快递以旧换新业务场景中用于退货单号</transferCode>
    <expressCompany>快递公司代码, string (50), 必填</expressCompany>
    <expressName>快递公司名称, string (50), 必填</expressName>
    <expressCode>快递单号, string (50), 必填</expressCode>
    <currentRouteCode>当前路由状态, string (50), 必填</currentRouteCode>
    <routes>
      <route>
        <time>处理时间, string (19), YYYY-MM-DD HH:MM:SS</time>
        <routeCode>路由编码, string (50)</routeCode>
        <address>路由发生地点, string (300)</address>
        <detail>详细说明, string (300)</detail>
      </route>
    </routes>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
</response>
`
let NotificaitonURL = 'NotificaitonURL'

export default { xmlRequest, xmlResponse, NotificaitonURL }



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.routing.push.js